// extracted by mini-css-extract-plugin
export default {"hamburger":"Hamburger_hamburger__0SYn4","active":"Hamburger_active__q+R0U"};